import { Navigate, useParams, type RouteObject } from "react-router-dom";
import { defaultLocale } from "@/lib/i18n/portal";
import { getSellerPath } from "@/lib/routing/portal-urls";

/**
 * Addresses a seller types or bookmarks that have no page of their own:
 * analytics lives on the dashboard and the team in settings. They are real
 * routes so the shell's `RouteAdmission` can explain a denied one ("Analytics
 * is a Premium feature") instead of the catch-all silently bouncing the seller
 * to the dashboard. Admitted, they forward to where the feature lives.
 */
function Forward({ to }: { to: string }) {
  const { locale = defaultLocale, storeSlug = "" } = useParams();
  return <Navigate to={getSellerPath(locale, storeSlug, to)} replace />;
}

export const accessAliasRoutes: RouteObject[] = [
  { path: "analytics", element: <Forward to="/dashboard" /> },
  { path: "team", element: <Forward to="/settings?section=team" /> },
];
